import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-custact-customers',
  templateUrl: './custact-customers.component.html',
  styleUrls: ['./custact-customers.component.css']
})
export class CustactCustomersComponent implements OnInit {
    argType;

    public argValue;

    public itemsListCustomers: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadCustomers() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListCustomers = await this.datatask.Post(1169, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadCustomers();
    }

    ngOnInit() {
        this.init();
    }
}
